export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  processFormValues() {
    const { firstName } = this.formValues
    return { firstName }
  },
})
